<template>
<zj-layout-container class="content project-home" v-loading="loading" :element-loading-text="loadingText">
  <zj-layout-main>
    <div class="zj-layout-main-content scrollable">
      <div class="project-home-top">
        <div class="project-nums">
          <div class="nums-item" v-for="(item, index) in list" :key="index" :class="item.class">
            <div class="nums-value">{{item.taskNum}}</div>
            <div class="nums-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="project-home-bottom">
        <div class="title">最新资料</div>
        <!-- <router-link to="xmzl">更多></router-link> -->
        <div class="project-home-content scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              border
              ref="multipleTable"
              style="width: 100%"
              fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="FileName" label="资料名称"></el-table-column>
              <el-table-column prop="AssocSubModule" label="所属项目"></el-table-column>
              <el-table-column prop="Extends2" label="分类"></el-table-column>
              <el-table-column prop="Extension" label="格式"></el-table-column>
              <el-table-column prop="Creater" label="上传人"></el-table-column>
              <el-table-column prop="FileSize" label="文件大小"></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </zj-layout-main>
</zj-layout-container>
</template>

<script>
import MyApis from "../../apis";
import ZJApp from "../../../../app";
export default {
  name: 'ZjProjectManagerHome',
  controller: 'UI',
  action: 'Home',
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      tableData: [],
      list:[
        // {
        //   title:'在建项目',
        //   class: 'blue',
        //   taskNum: 0
        // },
        {
          title:'逾期项目',
          class: 'orange',
          taskNum: 0
        },
        {
          title:'项目总数',
          class: 'roseRed',
          taskNum: 0
        },
        {
          title:'项目资料',
          class: 'green',
          taskNum: 0
        }
      ],
      culturaCodes: '', // 根据code获取组织结构列表code
      organization: ''  // 从登录获取组织机构code
    }
  },
  created() {
    this.getStatistical()
    this.getList()
  },
  mounted() {
    // this.$store.dispatch('submitIsShowbg', false);
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 获取首页数据
    getStatistical(){
      new MyApis.ProjectBasicinfoApi()
        .GetProjectSummary()
        .then((r) => {
          console.log(r)
          r = r.data.Data;
          // this.list[0].taskNum = r.ProjectFileCount
          this.list[0].taskNum = r.OverdueCount
          this.list[1].taskNum = r.TotalCount
          // this.list[3].taskNum = r.UnderConstructionCount
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getList() {
      let searchinfo = {
        AssocID: 'xiangmuzhil',
        AssocModule: '项目资料',
        PageSize: 7,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      this.loadingText = "加载中...";
      this.loading = true;
      new MyApis.FileApi()
        .GetFileList(searchinfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.FileList;
          this.list[2].taskNum = r.RecordCount
          // this.total = r.RecordCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    }
  },
  beforeDestroy() {
    // this.$store.dispatch('submitIsShowbg', true)
  }
}
</script>
<style scoped>
.project-home {
  padding: 0;
}
.project-home-top {
  box-sizing: border-box;
  border-bottom: 0.1rem dashed #00bcfe;
  /* background: #003669; */
  padding-bottom: 3rem;
  position: relative;
}
.project-nums {
  display: flex;
  /* justify-content: space-between; */
  margin-top: 5rem;
}
.nums-item {
  width: 20rem;
  height: 9.2rem;
  background: url('../../theme-default/images/project_nums_bg.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 3rem;
}
.blue {
  color: #08c7f1;
}
.orange {
  color: #ffb026;
}
.roseRed {
  color: #d800ff;
}
.green {
  color: #0dde79;
}
.nums-title {
  font-size: 1.4rem;
}
.nums-value {
  font-size: 3.4rem;
}

.project-home-bottom {
  position: relative;
  flex: 1;
  /* border: 0.1rem solid #00bcfe; */
  /* background: #003669; */
  padding: 3rem 0;
}
.project-home-bottom a {
  position: absolute;
  right: 5rem;
  top: 3rem;
  color: #fff;
  text-decoration: none;
}
.title {
  position: relative;
  text-align: center;
}
.title::after {
  content: '';
  width: 4rem;
  height: 0.1rem;
  position: absolute;
  left: calc(50% - 2rem);
  bottom: -1rem;
  background-image: linear-gradient(90deg,#00bcfe,#4ed1ff),linear-gradient(#000,#000);
}
.project-home-content {
  margin-top: 3rem;
}
</style>

